import {CAMPAIGN_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {FCCampaignNode, DTNode, Nodes} from 'common/src/modules/decisionTree/decisionTree.types';
import _keyBy from 'lodash/keyBy';

export default function getCampaignNodes({
  nodes,
  rootNodeId,
  fallbackCreativeNodeId,
  campaignNode,
}: {
  nodes: DTNode[];
  rootNodeId: number;
  fallbackCreativeNodeId: number;
  campaignNode: FCCampaignNode;
}): Nodes {
  const nodesById = _keyBy(nodes, 'id') as Record<string, DTNode>;

  nodesById[CAMPAIGN_NODE_ID] = {
    id: CAMPAIGN_NODE_ID,
    type: 0,
    x: campaignNode.x,
    y: campaignNode.y,
    outputs: [{nodeId: rootNodeId, id: 0}],
    inputs: [],
  };

  if (fallbackCreativeNodeId) {
    nodesById[fallbackCreativeNodeId].isFallbackCreative = true;
  }

  // add inputs to each node based on outputs of other nodes
  for (const node of Object.values(nodesById)) {
    for (const [idx, output] of node.outputs.entries()) {
      const nextNode = nodesById[output.nodeId];

      if (nextNode) {
        output.node = nextNode;
        nextNode.inputs.push({
          node,
          outputIdx: idx,
        });
      }
    }
  }

  return nodesById;
}
